import { Injectable } from '@angular/core';

/**
 * Stub for MsAdalAngular6Service when microsoft-adal-angular6 is not compatible with current Angular (e.g. Ivy).
 * Uses localStorage for basic auth state so app compiles and runs without the real ADAL package.
 */
@Injectable({ providedIn: 'root' })
export class MsAdalAngular6ServiceStub {
  isAuthenticated = true;
  LoggedInUserEmail = (typeof localStorage !== 'undefined' && localStorage.getItem('LoggedInUserEmail')) || '';

  logout(): void {
    localStorage.removeItem('LoggedInUserEmail');
    this.isAuthenticated = false;
    this.LoggedInUserEmail = '';
  }
}
